import { actionTypesEnum } from '../enum';

export const cantones = (state = null, action) => {

  if (action.type === actionTypesEnum.getCantones) {
    return action.payload;
  }

  return state;
};

export const distritos = (state = null, action) => {

  if (action.type === actionTypesEnum.getDistritos) {
    return action.payload;
  }

  return state;
};

export const barrios = (state = null, action) => {

  if (action.type === actionTypesEnum.getBarrios) {
    return action.payload;
  }

  return state;
};